import { Nullable } from '~/core/shared/types';
import { ApplicationDisplayData } from '~/core/shared/types/models';

export const getDocumentTitleForDisplayData = (
  displayData: Nullable<ApplicationDisplayData>,
): string => {
  if (displayData?.entityDisplayName) {
    return `${displayData.entityDisplayName}${displayData.statusDisplayName ? ` - ${displayData.statusDisplayName}` : ''}`;
  }
  return '';
};
